import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
import store from 'store2';
import { useDispatch } from 'react-redux';
import { appSliceActions } from '../../appSlices/appSlice';
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const dispatch = useDispatch();
  const handleNavClick = (detail, title) => {
    console.log(detail, title);
    if (detail >= 3 && title === 'debug') {
      const visibility = store('showDebugOptions');
      console.log(visibility)
      if (visibility) {
        dispatch(appSliceActions.toggleDebugOptions(false));
        store.set('showDebugOptions', false);
      } else {
        dispatch(appSliceActions.toggleDebugOptions(true));
        store.set('showDebugOptions', true);
      }
    }
  };
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
          <div key={item.title} onClick={(e) => handleNavClick(e.detail, item.title)}>
            <NavItem item={item} />
          </div>
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}
    </StyledNavItem>
  );
}
